import React from 'react';
import './EmployeeInfoCard.css';

const EmployeeInfoCard = ({ employee }) => {
  const user_role = sessionStorage.getItem('user_role');
  return (
    <div className="employee-info-card">
      <div className="employee-photo">
        <img 
  src={ process.env.PUBLIC_URL + '/images.jpg'} 
  alt={employee.name}
  style = {{margin: "-3px"}}
/>
      </div>
      <div className="employee-details">
        <h3>{employee.name}</h3>
        <p><strong>ID:</strong> {employee.id}</p>
        <p><strong>Role:</strong> {user_role}</p>
        {/* <p><strong>Designation:</strong> {employee.designation}</p>
        <p><strong>Reporting To:</strong> {employee.reportingManager}</p> */}
      </div>
    </div>
  );
};

export default EmployeeInfoCard;